<div class="background-image-container mt-ncs">
  <div class="container">
    <div class="jumbotron jumbotron-fluid">
      <div class="d-flex flex-wrap">
        <div>
          <h1 class="display-3" style="color: #f6961c;">CUEA Digital Repository</h1> <!-- Orange text for title -->
          <p class="lead" style="color: #ffffff;">The Catholic University of Eastern Africa (CUEA) Digital Repository is an open-source platform that enables the university to:</p>
        </div>
      </div>
      <ul style="color: #ffffff;">
        <li>easily store and manage academic documents, research outputs, audio, video, datasets, and their corresponding metadata</li>
        <li>provide open access to global and local audiences through OAI-PMH and metadata standards</li>
        <li>assign permanent and reliable URLs and identifiers, including integrations with handle.net and DataCite DOI for research publications</li>
      </ul>
      <p style="color: #ffffff;">Join the growing academic community at CUEA and explore our vast collection of scholarly works.</p>
      <p style="color: #ffffff;">For more information, please visit the following links:</p>
      <ul style="color: #ffffff;">
        <li><a href="https://cuea.edu" target="_blank" style="color: #f6961c;">CUEA Official Website</a></li>
        <li><a href="https://cuea.edu/Library" target="_blank" style="color: #f6961c;">CUEA Library</a></li>
        <li><a href="https://journal.cuea.edu/" target="_blank" style="color: #f6961c;">CUEA Journals</a></li>
        <li><a href="https://cuea.edu/ExamPastPapers" target="_blank" style="color: #f6961c;">Past Papers</a></li>
      </ul>
    </div>
  </div>
  <picture class="background-image">
    <source srcset="https://cuea.edu/wp-content/uploads/2024/07/1718972935487-1.jpg" media="(min-width: 600px)">
    <img src="https://cuea.edu/wp-content/uploads/2024/07/1718972935487-1.jpg" alt="CUEA Campus" />
  </picture>
</div>
